import React, { useEffect } from 'react';
import LogRocket from 'logrocket';
import { FinicityConnect } from '@finicity/connect-web-sdk';
import { LOGROCKET_APPID } from '../../../config/configuration';
import postWorkflowMessage from '../../../utils/post-workflow-message';

import styles from './FinicityConnect.module.scss';

const containerId = 'finicityconnect-container';
const iframeId = 'finicityConnectIframe';
const selector = `#${containerId}`;
const noop = () => {};
const connectionOptions = {
  selector,
  overlay: 'rgba(255,255,255, 0)',
};
const withLog = (name, handler) => (event) => {
  const message = `Finicity ${name} event`;
  if (LOGROCKET_APPID) LogRocket.log(message, event);
  else console.log(message, event); // eslint-disable-line no-console
  return handler(event);
};

const renderIframe = ({
  url,
  onComplete,
  onCancel,
  onError,
  setShowSkipButton,
}) => {
  const onRoute = ({ screen }) => {
    if (screen === 'search') {
      setShowSkipButton(true);
      postWorkflowMessage('WORKFLOW_READY');
    } else {
      setShowSkipButton(false);
      postWorkflowMessage('WORKFLOW_IN_PROGRESS');
    }
  };

  FinicityConnect.launch(url, {
    onDone: withLog('done', onComplete),
    onCancel: withLog('cancel', onCancel),
    onUser: withLog('user', noop),
    onError: withLog('error', onError),
    onRoute: withLog('route', onRoute),
    onLoad: withLog('load', () => {
      const iframeDomElement = document.getElementById(iframeId);
      iframeDomElement.setAttribute('class', styles.finicityConnect);
      iframeDomElement.setAttribute('data-cy', 'finicityconnect');
    }),
  }, connectionOptions);
};

export default function FinicityConnectView(props) {
  useEffect(() => {
    renderIframe({
      url: props.url,
      onComplete: props.onComplete,
      onCancel: props.onCancel,
      onError: props.onError,
      setShowSkipButton: props.setShowSkipButton,
      onLoadComplete: props.onLoadComplete,
    });
    return () => {
      FinicityConnect.destroy();
    };
  }, [
    props.url,
    props.onComplete,
    props.onCancel,
    props.onError,
    props.setShowSkipButton,
    props.onLoadComplete,
  ]);
  return (
    <div className={styles.finicityAligner}>
      <div id={containerId} />
    </div>
  );
}
